export default {
  allBoardingLines: [],
}
